import React from 'react';
import OrderEditor from '../common/OrderEditor';
import { salesOrdersAPI, customersAPI } from '../../services/api';

export default function SalesOrderForm() {
  return (
    <OrderEditor
      title="Sales Order"
      api={salesOrdersAPI}
      basePath="/sales-orders"
      partyLabel="Customer"
      loadParties={() => customersAPI.list({})}
      idField="customer_id"
      nameField="customer_name"
      dateField="order_date"
      secondLabel="Expected Date"
      secondField="expected_date"
      statuses={['Draft', 'Confirmed', 'Fulfilled', 'PartiallyFulfilled', 'Shipped', 'Closed', 'Cancelled']}
    />
  );
}
